"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6531],{

/***/ 46531:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ PrivacySidebar_PrivacySidebar; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/constant/index.tsx + 38 modules
var constant = __webpack_require__(17089);
;// CONCATENATED MODULE: ./src/views/PrivacyPolicy/components/PrivacySidebar/PrivacySidebar.tsx



var PrivacySidebar = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bg-white h-[100vh] pt-[8rem] sticky top-0 hidden lg:block",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-[2.3rem] sticky py-[1rem]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "text-[18px] leading-[32px] text-[#4B4B4B] font-medium",
                    children: "Menu"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                children: constant/* privacyPageMenuList */.oF === null || constant/* privacyPageMenuList */.oF === void 0 ? void 0 : constant/* privacyPageMenuList.map */.oF.map(function(item, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "block mb-[.8rem]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "text-[13px] leading-[25px] text-privacy font-semibold hover:text-primary duration-300",
                            href: item.link,
                            "aria-label": "".concat(item.text, " tab"),
                            children: item.text
                        })
                    }, "sjhedaetwey_" + i);
                })
            })
        ]
    });
};
/* harmony default export */ var PrivacySidebar_PrivacySidebar = (PrivacySidebar);

;// CONCATENATED MODULE: ./src/views/PrivacyPolicy/components/PrivacySidebar/index.ts




/***/ })

}]);